/** @jsxRuntime classic */
/** @jsx jsx */
import React from "react";
import { connect } from "react-redux";
import { jsx, css } from "@emotion/core";
import { primary_s20_l95 } from "../../shared/lib/colors";

import "./ProductAutocomplete.scss";

const ProductAutocomplete = ({
  innerRef,
  innerProps,
  product,
  primaryColor,
}) => {
  const style = css`
    &:hover {
      background-color: ${primary_s20_l95(primaryColor)};
    }
  `;

  return (
    <div
      className="product-autocomplete"
      ref={innerRef}
      {...innerProps}
      css={style}
    >
      {product.searchKeywords ? (
        <div className="vedi-tutti" style={{ color: primaryColor }}>
          Vedi tutti &raquo;
        </div>
      ) : (
        <table>
          <tbody>
            <tr>
              <td className="image">
                <img src={product.image} className="img-fluid" />
              </td>
              <td className="text">{product.name}</td>
            </tr>
          </tbody>
        </table>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  primaryColor: state.store.singleStore.brandColor,
});

export default connect(mapStateToProps)(ProductAutocomplete);
